/* eslint-disable */
import React, { useState } from "react";

const ContactForm = ({ ContactMessage }) => {
  const [Email, setEmail] = useState("");
  const [Message, setMessage] = useState("");
  const [Name, setName] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <div className="form animation-element">
      <form onSubmit={handleSubmit} className="message-form">
        <div className="form-item-container">
          <input
            placeholder="Name"
            className="message-input"
            type="text"
            name="Name"
            onChange={(e) => {
              setName(e.target.value);
            }}
            value={Name}
            required
          />
        </div>
        <div className="form-item-container">
          <input
            value={Email}
            placeholder="Enter email"
            className="message-input"
            type="email"
            name="Email"
            onChange={(e) => {
              setEmail(e.target.value);
            }}
            required
          />
        </div>
        <div className="form-item-container">
          <textarea
            value={Message}
            className="message-input"
            placeholder="Your Message"
            type="text"
            name="Message"
            onChange={(e) => {
              setMessage(e.target.value);
            }}
            required
          ></textarea>
        </div>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={`mailto:priyabihani.official@gmail.com?subject=Hello%20Priya!&body=${
            Message + "," + "from " + Email
          }`}
        >
          <div id="submit" className="text-center submit-button">
            Submit
          </div>
        </a>
      </form>
    </div>
  );
};

export default ContactForm;
